// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__PczCb"};